<template lang="html">
  <div>
    <div class="card">
      <div class="card-header">
        <h1>
          <label>
            Importar Planilha
          </label>
        </h1>
      </div>
      <div class="card-body">
        <b-tabs>
          <b-tab no-body title="Arquivos">
            <label for="">
              Anexar arquivos <span class="text-muted text-sm">(Formato XLS/XLSX com tamanho máx: 5Mb)</span>
            </label>
            <uploader
              :id="'archive'"
              :url="mediaUrl"
              ref="archive"
              :name="'file'"
              :value="form.archive"
              :form="form"
              :collection="'customer_archive'"
              :max-file="1"
              :accept="'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/excel'"
              :extensions="xls,xlsx">
            </uploader>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <div class="card-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
  import { store } from '@/vuex/store'
  import Uploader from '../../ui/Uploader.vue'
  export default {
    props: {
      form: {
        type: [Object],
        required: true
      },

      submitted: {
        type: Boolean,
        default: false
      },

      instance: {
        type: Object,
        default () {
          return {
            media: []
          }
        }
      },
      http: {
        type: Object,
        required: true
      }
    },

    data () {
      return {
        archive: [],
        empty: {
          archive: []
        }
      }
    },

    components: {
      Uploader,
      store
    },

    computed: {
      mediaUrl () {
        return this.http.routes.uploadMedia(this.instance.id)
      }
    },

    created () {
      const self = this

      self.form.withData(self.instance.id ? self.instance : self.empty)
        .setInitialValues(self.instance.id ? self.instance : self.empty)
    },

    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/forms/Rte/Customer.vue